import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-List-block",
  "use": "icon-List-block-usage",
  "viewBox": "0 0 827.23 513.85",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 827.23 513.85\" id=\"icon-List-block\"><defs></defs><title>List-block</title><g id=\"icon-List-block_图层_2\" data-name=\"图层 2\"><g id=\"icon-List-block_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M27.54,0H799.7c25,0,37,39.23,18.63,60.89L449.4,495.27c-21.11,24.85-53.65,24.77-74.68-.19L8.83,60.79C-9.46,39.08,2.57,0,27.54,0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol